import { Select } from "antd";
import React from "react";

export default function ActivityTimelineCard(props) {
  return (
    <div
      {...props}
      className="w-[290px] h-[365px] px-4 py-5 bg-white rounded-2xl shadow border border-primary50 flex-col justify-between items-start gap-6 flex"
    >
      <div className="w-full flex flex-col justify-between gap-4">
        <div className="w-full flex justify-center items-center">
          <h3 className="text-center text-basePrimary text-base font-semibold leading-normal">
            {props.heading}
          </h3>
        </div>
        <div className="justify-center items-center gap-2 inline-flex">
          <p className="text-center text-[#222222] text-sm font-normal font-['Poppins'] leading-tight">
            Select Date:
          </p>
          <Select
            showSearch
            style={{
              width: 150,
              height: 48,
            }}
            placeholder="Please Select"
            options={[
              {
                value: "1",
                label: "Last Weeks",
              },
              {
                value: "2",
                label: "Last Months",
              },
              {
                value: "3",
                label: "Last 2 Months",
              },
              {
                value: "3",
                label: "Life Time",
              },
            ]}
          />
        </div>
        <div className="flex-col justify-start items-start gap-2.5 flex">
          {props.children}
        </div>
      </div>
      <p className="text-secondary text-base font-normal underline leading-normal">
        <a href="#">View more</a>
      </p>
    </div>
  );
}
